var path = '/shared/javascripts/templates/angular_to_svelte.html';
var html = "<span id='svelte-wrapper-{{$id}}' ng-class=\"extraSvelteSpanClass ? extraSvelteSpanClass : ''\"></span>";
window.angular.module('tiz').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;